import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import UserPurchaseContext from '~/context/home/UserPurchaseContext';
import { fetchUserPurchasing } from '~/services/common';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetUserPurchase() {
  const {
    userState: { isLoaded }
  } = useContext(UserContext);
  const {
    userPurchase: { setLoading, setData, setError, setLoaded }
  } = useContext(UserPurchaseContext);
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (!isLoaded || !isLoggedIn) {
        setLoaded();

        return;
      }

      setLoading();

      fetchUserPurchasing(controller)
        .then(setData)
        .catch(
          generateErrorLogger(
            'User Purchase',
            {},
            { callback: setError, controller }
          )
        );
    },
    [isLoaded, isLoggedIn, setData, setError, setLoaded, setLoading]
  );
}
